import { introductionContent } from "./introduction";
import { pillar1Content } from "./pillar1";
import { pillar2Content } from "./pillar2";

export type { PageContent, PageContentSource, PagePdf } from "./types";

export const pageContent = {
	...introductionContent,
	...pillar1Content,
	...pillar2Content,
};
